<template>
  <default-layout
    ref="layout"
    :overlayStatus="globalShowOverlayStatus"
    :toggleOverlayStatus="toggleOverlayStatus"
  >
    <vue-headful
      v-if="!!currentExterior"
      :title="`${project.name} | ${currentExterior.name}`"
    />
    <back-button
      v-if="fabBackButtonVisible && $vuetify.breakpoint.mdAndUp"
      :move-back="false"
      @click="goToParentExterior"
      button-class="scale-down-size"
    />
    <template
      v-if="exteriors && currentExterior && !loadingExteriors && (filteredExteriors.length > 1)"
      slot="mobileExteriorNavigation"
    >
      <v-container class="hidden-md-and-up mobile-exterior-navigation">
        <v-layout align-top flex-nowrap justify-space-center row>
          <v-flex
            v-if="prevExteriorId && prevExteriorId"
            class="ma-auto navigate-exterior-arrow"
          >
            <router-link
              :disabled="!prevExteriorId"
              :tag="!prevExteriorId ? 'button' : 'a'"
              :to="{
                name: 'order.overview.exterior',
                params: { order: $route.params.order, exteriorId: prevExteriorId }
              }"
              class="turquoise--text"
            >
              <v-icon>navigate_before</v-icon>
            </router-link>
          </v-flex>
          <v-flex class="ma-auto text-center exterior-facade-name" sm9 xs9>
            {{ currentExterior.name }}
          </v-flex>
          <v-flex
            v-if="prevExteriorId && nextExteriorId"
            class="ma-auto navigate-exterior-arrow"
          >
            <router-link
              :disabled="!nextExteriorId"
              :tag="!nextExteriorId ? 'button' : 'a'"
              :to="{
                name: 'order.overview.exterior',
                params: { order: $route.params.order, exteriorId: nextExteriorId }
              }"
              clall="turquoise--text"
            >
              <v-icon>navigate_next</v-icon>
            </router-link>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
    <template
      v-if="exteriors && currentExterior && !loadingExteriors"
    >
      <Exterior
        v-if="$vuetify.breakpoint.smAndDown"
        :currentExterior="currentExterior.exterior_id"
        :exteriors="exteriors"
        :selectedOverlay="selectedOverlay"
        :overlayStatus="globalShowOverlayStatus"
        :toggleOverlayMobile="toggleOverlayMobile"
        :toggleOverlayStatus="toggleOverlayStatus"
      />
      <Exterior
        v-else
        :currentExterior="currentExterior.exterior_id"
        :exteriors="exteriors"
        :overlayStatus="globalShowOverlayStatus"
        :toggleOverlayStatus="toggleOverlayStatus"
        input-class="scale-down-size"
      />
    </template>
    <circle-spin
      v-if="loadingExteriors"
      :loading="loadingExteriors"
      class="turquoise--text"
      height="250"
      width="250"
    />

    <div :class="[
      'center-elements',
      'scale-down-size',
      { 'move-above-cards': overlaysByLinkedExteriors && overlaysByLinkedExteriors.length }]">
    <!-- Visual Disclaimer -->
      <div v-if="disclaimerVisible" class="visual-disclaimer-wrapper">
        <VisualDisclaimer :html="settings.visual_disclaimer" :open="disclaimerOpen" @close="disclaimerOpen = false" />
      </div>

      <v-container
        v-if="exteriorNavBarVisible"
        class="exterior-controls-group"
      >
        <div :class="exteriorSwitcherVisible ? 'exterior-controls-group__wrap' : 'exterior-controls-group__single'">
          <div v-if="exteriorSwitcherVisible" class="exterior-controls-group__label">
            <v-row no-gutters align-center justify-space-around class="filter-menu-button-dock flex-nowrap">
              <v-col
                v-if="filteredExteriors.length"
                class="text-center navigate-exterior-arrow float-left flex-grow-0 flex-shrink-0"
              >
                <v-btn
                  :disabled="!prevExteriorId"
                  :to="{
                name: 'order.overview.exterior',
                params: { order: $route.params.order, exteriorId: prevExteriorId }
              }"
                  class="ml--10"
                  color="white"
                  fab
                  icon
                  text
                >
                  <v-icon color="turquoise--text">navigate_before</v-icon>
                </v-btn>
              </v-col>
              <v-divider
                v-if="filteredExteriors.length"
                class="float-left"
                vertical
              />
              <v-col
                v-if="filteredExteriors.length"
                class="exterior-select-container"
                :class="{'simple-exterior-name-mode': simpleExteriorNameMode}"
              >
                <v-select
                  v-if="!simpleExteriorNameMode"
                  v-model="currentExteriorId"
                  :items="sortedExteriors"
                  :ripple="false"
                  :show-label="false"
                  class="py-0 my-0 exterior-select turquoise--text"
                  dense
                  flat
                  height="24px"
                  hide-details
                  item-text="name"
                  item-value="exterior_id"
                  @change="handleExteriorSelect"
                />
                <div v-else class="simple-exterior-name-container">
                  <div class="simple-exterior-name">
                    {{ exteriorName }}
                  </div>
                </div>
              </v-col>
              <v-divider
                v-if="filteredExteriors.length"
                class="float-left"
                vertical
              />
              <v-col
                v-if="filteredExteriors.length"
                class="text-center navigate-exterior-arrow float-right flex-grow-0 flex-shrink-0"
              >
                <v-btn
                  :disabled="!nextExteriorId"
                  :to="{
                name: 'order.overview.exterior',
                params: { order: $route.params.order, exteriorId: nextExteriorId }
              }"
                  color="white"
                  fab
                  icon
                  text>
                  <v-icon class="turquoise--text">navigate_next</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <div class="exterior-controls-group__filter">
            <filter-menu-button
              v-if="$vuetify.breakpoint.mdAndUp && filteringAllowed"
              :exterior="currentExterior"
              @filtering="toggleOverlayStatus(true)"
            />
          </div>
        </div>
      </v-container>
    </div>
    <v-sheet
      v-if="mobileOverlayAvailable"
      class="mobile-overlay-slider"
      max-width="100%"
    >
      <v-slide-group
        ref="mobileOverlaySlider"
        v-model="selectedOverlay"
        center-active
        min-height="142"
      >
        <v-slide-item
          v-for="overlay in overlaysByLinkedExteriors"
          :key="overlay.overlay_id"
          v-slot:default="{ active, toggle }"
          :value="overlay.overlay_id"
        >
          <v-card
            :class="['fill-height', 'mx-3', 'overlay-tooltip']"
            :color="active ? 'white' : 'rgba(255, 255, 255, 0.7)'"
            align="center"
            height="82"
            justify="center"
            width="270"
            @click="processedSliderClick(overlay, active, toggle)"
          >
            <v-row
              align="center"
              class="fill-height"
              justify="center"
            >
              <v-col v-if="getSlideItemContent(overlay).unit" align-self="start" class="text-left mobile-overlay-box" sm5>
                <h3>{{ getSlideItemContent(overlay).name }}</h3>
                <template v-if="getSlideItemContent(overlay).rooms">
                  {{ getSlideItemContent(overlay).rooms }}
                  {{
                    $t(getAttrLabel('rooms'))
                      .toLowerCase()
                  }}<br/>
                </template>
                {{ getSlideItemContent(overlay).size_gross }}<br/>
              </v-col>
              <v-col
                v-if="getSlideItemContent(overlay).unit"
                class="text-left mobile-overlay-box"
                sm5
              >
                <span
                  :class="['unit-status-badge', getSlideItemContent(overlay).statusColor]"
                  :style="!!getSlideItemContent(overlay).statusColorHex
                    ? {'--overlay-status-color': getSlideItemContent(overlay).statusColorHex}
                    : {}
                  "
                >
                  {{ $t(getSlideItemContent(overlay).statusName) }}
                </span>
                <br/>
                {{ getSlideItemContent(overlay).price }}<br/>
                {{ getSlideItemContent(overlay).fee_monthly }}<br/>
              </v-col>
              <v-col
                v-if="!getSlideItemContent(overlay).unit"
                class="text-left mobile-overlay-box"
                sm10
              >
                <h3>{{ getSlideItemContent(overlay).name }}</h3>
              </v-col>
              <v-col class="goto-arrow" sm2>
                <v-icon
                  class="turquoise--text"
                  size="36"
                  v-text="'mdi-chevron-right'"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
    <div class="top-right-floating">
      <v-card
        v-if="minimapToggler"
        class="minimap__wrapper"
        max-width="240"
        origin="right top"
        transition="scale-transition"
      >
        <v-btn
          class="minimap__close-button"
          color="accent"
          flat
          icon
          @click="minimapToggler = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <div
          class="floor-map"
          @click="minimapFullDialog = true"
        >
          <v-lazy-image
            v-if="minimapImage"
            :src="minimapImage"
            class="floor-map__plan"
          />
        </div>
        <div class="minimap__floor-name accent--text">
          Exterior minimap
        </div>
      </v-card>
    </div>
    <v-dialog
      v-model="minimapFullDialog"
      max-width="650"
    >
      <v-card class="text-center">
        <v-lazy-image
          v-if="minimapImageLarge"
          :src="minimapImageLarge"
          class="floor-map__plan my-5 mx-3"
        />
      </v-card>
    </v-dialog>
  </default-layout>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import DefaultLayout from '@/layouts/Default.vue';
import Exterior from '@/components/Exterior.vue';
import OverlayStatusMixin from '@/mixins/exteriorOverlayStatus';
import ActiveExteriorChecker from '@/mixins/activeExteriorChecker';
import ExteriorNavigator from '@/mixins/ExteriorNavigator';
import IconSunMoon from '@/components/icons/SunMoon.vue';
import { cdnUrl } from '@/utils/urls';
import { attrKey2Label } from '@/utils/attribute-labels';
import { pricesAttributes } from '@/utils/attribute-prices';
import { CircleSpinner } from 'vue-spinners';
import VLazyImage from 'v-lazy-image';
import VueHeadful from 'vue-headful';
import BackButton from '@/components/BackButton.vue';
import FilterMenuButton from "@/components/FilterMenuButton.vue";
import FilterMenuButtonMobile from "@/components/FilterMenuButtonMobile.vue";
import VisualDisclaimer from "@/components/VisualDisclaimer.vue";

const MIN_EXTERIOR_NUM_FOR_SELECT = 4;

/* eslint-disable no-empty, array-callback-return */
export default {
  /**
   * The name of the page.
   */
  name: 'OrderOverview',

  mixins: [OverlayStatusMixin, ActiveExteriorChecker, ExteriorNavigator],

  /**
   * The components that the page can use.
   */
  components: {
    FilterMenuButtonMobile, FilterMenuButton,
    BackButton,
    Exterior,
    DefaultLayout,
    IconSunMoon,
    CircleSpinner,
    VLazyImage,
    VueHeadful,
    VisualDisclaimer,
  },
  computed: {
    ...mapGetters('exteriors', ['exteriors', 'globalShowOverlayStatus', 'currentExterior']),
    ...mapGetters('units', ['unitById', 'units']),
    ...mapGetters('unitTypes', ['unitTypeById']),
    ...mapGetters('project', ['project', 'languageDefault', 'attributes', 'statuses', 'settings']),
    ...mapGetters('service', ['topmenu']),
    filteredExteriors() {
      return (
        this.currentExterior.parent
          ? this.exteriors.filter(ext => (
            parseInt(ext.parent, 10) === this.currentExterior.parent
            && this.checkExteriorStatus(this.exteriors, ext, this.statuses)
          ))
          : this.exteriors.filter(ext => !ext.parent)
      )
        .filter(e => e.display_navigator);
    },
    sortedExteriors() {
      // It's for dropdown only! It must be alpabetically sorted
      return this.filteredExteriors.slice()
        .sort((ext1, ext2) => (
          ext1.name < ext2.name
            ? -1
            : +(ext1.name !== ext2.name)
        ));
    },
    currentExteriorIndex() {
      const { exterior_id: id } = this.currentExterior;

      return this.filteredExteriors.findIndex(e => e.exterior_id === id);
    },
    prevExteriorId() {
      const { filteredExteriors, currentExteriorIndex: currentIndex } = this;
      const index = currentIndex > 0 ? currentIndex - 1 : filteredExteriors.length - 1;

      return filteredExteriors[index].exterior_id;
    },
    nextExteriorId() {
      const { filteredExteriors, currentExteriorIndex: currentIndex } = this;
      const index = currentIndex >= (filteredExteriors.length - 1) ? 0 : currentIndex + 1;

      return filteredExteriors[index].exterior_id;
    },
    fabBackButtonVisible() {
      return this.currentExterior && this.currentExterior.parent;
    },
    simpleExteriorNameMode() {
      return this.filteredExteriors.length < MIN_EXTERIOR_NUM_FOR_SELECT;
    },
    exteriorName() {
      const { name } = this.filteredExteriors.find(({ exterior_id: id }) => id === this.currentExteriorId) || {};
      return name;
    },
    exteriorNavBarVisible() {
      const multiview = !this.loadingExteriors && this.currentExterior;
      const isOverviewPage = this.$route.path.endsWith('overview');

      return multiview && (!isOverviewPage || this.filteredExteriors.length > 1) && (this.$vuetify.breakpoint.mdAndUp || !this.topmenu);
    },
    exteriorSwitcherVisible() {
      return this.filteredExteriors.length > 1;
    },
    overlaysByLinkedExteriors() {
      return this.sortOverlaysByLinkedExteriors(this.currentExterior.overlays)
        .filter(overlay => this.getSlideItemContent(overlay));
    },
    mobileOverlayAvailable() {
      return this.exteriors && !this.loadingExteriors && this.$vuetify.breakpoint.smAndDown;
    },
    disclaimerVisible() {
      return !!(this.settings && this.settings.visual_disclaimer) && this.disclaimerOpen;
    },
  },
  watch: {
    $route(to) {
      if (to.params.exteriorId) {
        this.currentExteriorId = parseInt(to.params.exteriorId, 10);
      }
    },
    mobileOverlayAvailable(value) {
      if (!value) {
        return;
      }
      // this is a workaround fixing the issue when VSlideGroup doesn't do touch
      // scrolling (its internal widths are 0 because of v-if)
      const interval = setInterval(() => {
        if (!this.$refs.mobileOverlaySlider) {
          return;
        }

        this.$refs.mobileOverlaySlider.setWidths();

        if (this.$refs.mobileOverlaySlider.widths.content && this.$refs.mobileOverlaySlider.widths.wrapper) {
          clearInterval(interval);
        }
      }, 500);
    },
    exteriorNavBarVisible(value) {
      this.setExteriorNavBarVisible(value);
    },
  },
  /* eslint-disable max-len */
  beforeMount() {
    if (!this.$store.state.unitTypes.unitTypes.length) {
      this.$store.dispatch('unitTypes/load', { order: this.$route.params.order });
    }

    this.$store
      .dispatch('exteriors/load', { order: this.$route.params.order })
      .then((res) => {
        this.loadingExteriors = false;

        // preload images from overlays of exteriors
        const exteriors = res.data;

        if (exteriors.length > 0) {
          exteriors.map((exterior) => {
            if (exterior.image) {
              try {
                const img = new Image();
                img.src = cdnUrl(exterior.image);
              } catch (e) {
              }
            }
          });
        }
        this.$store.dispatch('units/load', { order: this.$route.params.order });
        this.$store.dispatch('filters/load', { order: this.$route.params.order });

        this.currentExteriorId = this.currentExterior.exterior_id;
        this.mobileSelectedOverlay = 0;
      });
  },
  mounted() {
    document.addEventListener('keydown', this.navigateWithKeyboard);
  },
  destroyed() {
    document.removeEventListener('keydown', this.navigateWithKeyboard);
  },
  /* eslint-enable */
  data() {
    return {
      currentExteriorId: 0,
      loadingExteriors: true,
      selectedOverlay: null,
      minimapToggler: false,
      disclaimerOpen: true,
      minimapImage: 'https://qa.diakrit.com/orderfiles/640000/645100/6451366/panorama/15538_minimap.png?1567091043&amp;height=999&amp;width=170',
      minimapImageLarge: 'https://qa.diakrit.com/orderfiles/640000/645100/6451366/panorama/15538_minimap.png?1567091043&amp;height=999&amp;width=999',
      minimapFullDialog: false,
    };
  },
  methods: {
    ...mapMutations('service', ['setExteriorNavBarVisible']),
    filteringAllowed() {
      return this.currentExterior.overlays.some(overlay => this.unitById(overlay.unit_id))
    },
    navigateWithKeyboard(event) {
      if (event.code === 'ArrowRight') {
        this.$router.push({
          name: 'order.overview.exterior',
          params: { order:  this.$route.params.order, exteriorId: this.nextExteriorId }
        })
      } else if (event.code === 'ArrowLeft') {
        this.$router.push({
          name: 'order.overview.exterior',
          params: { order:  this.$route.params.order, exteriorId: this.prevExteriorId }
        })
        event.preventDefault();
      }
    },
    handleExteriorSelect(exteriorId) {
      this.$router.push({
        name: 'order.overview.exterior',
        params: { order: this.$route.params.order, exteriorId },
      });
    },
    getSlideItemContent(overlay) {
      if (overlay.link_active && !!overlay.url) {
        return {
          unit: false,
          name: overlay.label,
          label: overlay.label,
        };
      } else if (overlay.linked_exterior_id) {
        const statusAvailable = this.statuses.find(status => status.internal_slug === 'available');
        const exteriorUnits = this.units.filter(unit => (
          unit.exteriors || []).includes(overlay.linked_exterior_id));
        const availableUnits = !statusAvailable ? [] : exteriorUnits.filter(unit =>
          unit.status_id === statusAvailable.status_id);
        const exterior = this.exteriors.find(ext => ext.exterior_id === overlay.linked_exterior_id);

        return {
          unit: false,
          name: exterior.name,
          label: overlay.label,
          availableNum: availableUnits.length,
          totalNum: exteriorUnits.length,
        };
      } else if (overlay.unit_id) {
        const unit = this.unitById(overlay.unit_id);

        if (!unit) {
          return false;
        }

        const unitType = this.unitTypeById(unit.unit_type_id);
        const attributesMeta = Object
          .keys(unit.attributes)
          .concat(unitType ? Object.keys(unitType.attributes) : []);
        const unitAttrData = {};

        attributesMeta.forEach((key) => {
          if (this.isPriceAttributeHidden(unit, key)) {
            return;
          }

          if (typeof unit.formatted_attributes[key] !== 'undefined' && unit.formatted_attributes[key] !== null) {
            unitAttrData[key] = unit.formatted_attributes[key];
          } else if (unitType) {
            if (typeof unitType.formatted_attributes[key] !== 'undefined' && unitType.formatted_attributes[key] !==
              null) {
              unitAttrData[key] = unitType.formatted_attributes[key];
            } else {
              unitAttrData[key] = unitType.attributes[key];
            }
          }
        });

        const overlayStatus = this.statuses.find(status => status.status_id === unit.status_id);

        return Object.assign({}, {
          unit: true,
          name: unit.name,
          statusName: unit.status.name || unit.status.internal_slug,
          statusColor: overlayStatus.color_class,
          statusColorHex: overlayStatus.color,
        }, unitAttrData);
      }

      return {};
    },
    processedSliderClick(overlay, active, toggle) {
      this.toggleOverlayMobile(overlay.overlay_id);
      if (active) {
        this.goTo(overlay);
      } else {
        toggle();
      }
    },
    toggleOverlayMobile(overlayId) {
      this.selectedOverlay = overlayId;
    },
    goTo(overlay) {
      const status = this.statuses.find(status => status.status_id === overlay.status_id);

      if (!status.accessible) {
        return;
      }

      if (!this.checkExteriorStatusForOverlays(overlay)) {
        return;
      }

      const unit = overlay.unit_id && this.unitById(overlay.unit_id);

      if (status && status.exturl && unit && unit.exturl) {
        window.open(unit.exturl, this.settings.unit_exturl_target);
        return;
      }

      if (overlay.link_active && !!overlay.url) {
        window.open(overlay.url, overlay.target);
        return;
      }

      const location = overlay.linked_exterior_id
        ? {
          name: 'order.overview.exterior',
          params: { order: this.$route.params.order, exteriorId: overlay.linked_exterior_id },
        }
        : {
          name: 'order.unit.view',
          params: { order: this.$route.params.order, unitId: overlay.unit_id },
        };

      this.$router.push(location);
    },
    getAttrLabel(key) {
      return attrKey2Label[key];
    },
    isPriceAttributeHidden(unit, key) {
      if (!pricesAttributes.includes(key)) {
        return undefined;
      }

      const status = this.statuses.find(status =>
        status.status_id === unit.status.status_id);

      return !status.display_price;
    },
    sortOverlaysByLinkedExteriors(overlays) {
      const result = [];

      this.exteriors.forEach((ext) => {
        const linkedOverlay = overlays.find(overlay =>
          overlay.linked_exterior_id === ext.exterior_id);

        if (linkedOverlay) {
          result.push(linkedOverlay);
        }
      });

      return result.concat(overlays.filter(overlay => overlay.linked_exterior_id === 0));
    },
    goToParentExterior() {
      this.goToExterior(this.exteriors.find(exterior => exterior.exterior_id === this.currentExterior.parent));
    },
  },
};
</script>

<style lang="scss">
@mixin simple-exterior-name {
  color: var(--overview-color, #646464);
  font-size: 1em;
  text-decoration: var(--exterior-navbar-text-decoration, none);
  line-height: 18px;
  font-weight: 500;
  position: absolute;
  margin: 0;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  max-width: 100%;
  text-align: center;
  overflow: hidden;
  justify-content: center;
}

.scale-down-size {
  transition: transform 0.3s ease;

  @media (max-width: 1500px), (max-height: 920px) {
    transform: scale(0.85);
  }
}

.simple-exterior-name {
  @include simple-exterior-name;
  display: flex;
  flex-direction: column;
}

.simple-exterior-name-mode {
  height: 100%;
}

.simple-exterior-name-container {
  min-height: 100%;
  position: relative;
  flex: 1 1 auto;
}

.center-elements{
  position: fixed;
  bottom: var(--app-main-padding);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  transition: none;
}

.exterior-controls-group__filter:has(> button) {
  margin-left: 30px;
}

.exterior-controls-group {
  max-width: 436px;
  height: 56px;
  padding: 0;
  width: 100%;
  transition: margin 0.3s ease;

  &__label {
    width: 100%;
    border-radius: 28px;
    background-color: #fff;
    box-shadow: var(--exterior-controls-group-box-shadow, 0 0 8px 0 rgba(0, 0, 0, 0.12), 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 14px 0 rgba(0, 0, 0, 0.12), 0 14px 14px 0 rgba(0, 0, 0, 0.24));
  }
  &__filter {
    background-color: #fff;
    border-radius: 28px;
    margin-left: 0;
  }
  &__wrap {
    display: flex;
    justify-content: space-between;
  }
  &__single {
    display: flex;
    justify-content: center;
  }
  .row {
    height: 56px;
    padding: 0;
  }

  .exterior-select-container {
    flex: 1 1;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .exterior-select {
    font-size: 1em;

    .v-input__slot {
      &::before {
        display: none;
      }

      &::after {
        border-style: none;
      }
    }

    .v-select__slot {
      & > .v-label {
        left: 50% !important;
        transform: translateX(-50%);
      }
    }

    .v-list-item__title {
      text-align: center;
    }

    .v-select__selections {
      position: relative;
      overflow: hidden;
    }

    .v-select__selection {
      @include simple-exterior-name;
    }
  }
}

@media (min-width: 1500px) {
  .center-elements {
    width: 80%;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media (max-width: 1500px), (max-height: 920px) {
  .center-elements {
    bottom: 2px;
  }

  .center-elements:has(> div.exterior-controls-group:first-child) {
    margin-bottom: 6px;
  }
}

@media screen and (max-width: 960px) {
  .center-elements {
    bottom: 15px;
  }

  .center-elements.move-above-cards {
    bottom: calc(var(--app-main-padding) + 80px);
  }

  .mobile-overlay-box {
    padding: 2px 12px 0 12px !important;
  }
  .exterior-controls-group {
    top: 20px;
    max-width: 80vw;
  }

  .mobile-overlay-slider {
    position: fixed;
    bottom: 6px;
    left: 0;
    background-color: transparent !important;

    .row {
      margin-left: 0;
      margin-right: 0;
    }

    .v-card {
      padding-bottom: 0;
      padding-top: 0;
      margin-bottom: 3px;
    }

    h3 {
      font-weight: 500;
    }
  }
}

.navigate-exterior-arrow {
  a {
    text-decoration: none;
  }

  button[disabled] {
    cursor: default;

    .v-icon {
      color: rgba(0, 0, 0, 0.38) !important;
    }
  }

  &.float-right {
    margin-right: 6px;

    .v-icon {
      color: var(--overview-color, var(--primary-color)) !important;
    }
  }

  &.float-left {
    margin-left: 14px;

    .v-icon {
      color: var(--overview-color, var(--primary-color)) !important;
    }
  }
}

.mobile-exterior-navigation {
  min-width: 250px;
  margin: 0 5px;
  padding: 0;
  display: flex;
  flex-direction: column;

  .row {
    margin-right: 0;
    margin-left: 0;
  }

  .exterior-facade-name {
    text-transform: uppercase;
  }
}

@media screen and (max-width: 400px) {
  .mobile-exterior-navigation {
    min-width: 144px;
  }
}

.ml--10 {
  margin-left: -10px;
}

.floor-map {
  position: relative;

  &:hover {
    cursor: pointer;
  }
}

.floor-map__plan {
  height: 100%;
  width: 100%;
}
.visual-disclaimer-wrapper {
  bottom: calc(var(--app-main-padding) + 80px);
  display: flex;
  justify-content: center;
  pointer-events: none;
  z-index: 7;

  > * {
    pointer-events: auto;
  }
}
</style>
